export default __webpack_public_path__ + "static/media/mainHeader.e3533b8b.jpg";